import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import { makeStyles } from '@material-ui/core/styles';

import { pantonFonts } from 'components/theme/common';
import { getRedesignDialogColors } from './redesignDialogColors';

const useStyles = makeStyles(
  (theme) => {
    const colors = getRedesignDialogColors(theme);
    const xs = theme.breakpoints.down('xs');
    return {
      // Below the scrolling body, so it stays in view (on a phone, at the
      // bottom of the screen); a hairline over it.
      footer: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: theme.spacing(1.5),
        flexShrink: 0,
        boxSizing: 'border-box',
        padding: theme.spacing(1.5, 3),
        borderTop: `1px solid ${colors.border}`,
        [xs]: {
          padding: theme.spacing(1.5, 2),
        },
      },
      // Full screen: clear of the home indicator.
      safeArea: {
        '&&': {
          paddingBottom: `calc(${theme.spacing(
            1.5
          )}px + env(safe-area-inset-bottom, 0px))`,
        },
      },
      // Status text or progress at the left, in the muted colour.
      start: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        flex: '1 1 auto',
        minWidth: 0,
        color: colors.muted,
        fontFamily: pantonFonts.panton,
        fontSize: '0.875rem',
        lineHeight: 1.4,
        [xs]: {
          flexBasis: '100%',
        },
      },
      // The actions at the right; on a phone a row of their own whose
      // buttons share its width.
      actions: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        flexWrap: 'wrap',
        gap: theme.spacing(1),
        marginLeft: 'auto',
        [xs]: {
          flex: '1 1 100%',
          '& > *': {
            flex: '1 1 auto',
          },
        },
      },
    };
  },
  { name: 'LixRedesignDialogFooter' }
);

/** The dialog's footer: `start` at the left, `actions` at the right. */
function RedesignDialogFooter({ start, actions, safeArea }) {
  const classes = useStyles();
  return (
    <div
      className={clsx(classes.footer, safeArea && classes.safeArea)}
      data-redesign-dialog-footer="true"
    >
      {start ? <div className={classes.start}>{start}</div> : null}
      {actions ? <div className={classes.actions}>{actions}</div> : null}
    </div>
  );
}

RedesignDialogFooter.propTypes = {
  start: PropTypes.node,
  actions: PropTypes.node,
  safeArea: PropTypes.bool,
};

export default RedesignDialogFooter;
